import { useEffect, useRef, useState } from 'react';
import LayeredDashboardHeader from '../../LayeredDashboardHeader';
import useCustomNavigate from '../../../components/operational/goBack';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import CreateAction from '../../../components/operational/createAction';
import { useNavigate } from 'react-router-dom';
import Plans from '../Plans';
import Stepper from '../../../components/ui/Stepper/Stepper';
import BillingMain from '../Payment/BillingMain';
import Payment from '../Payment/Payment';

const LicensePurchase = ({ tab }) => {
  const formButtonRef = useRef();
  const [billingAdress, setBillingAdress] = useState({});
  const [license, setLicense] = useState({});
  const goBack = useCustomNavigate(tab);
  const [activeStep, setActiveStep] = useState({ index: 0, direction: 'right' });

  const navigate = useNavigate();

  const onPlanSelect = plan => {
    if (plan) {
      setActiveStep(state => ({ index: 1, direction: 'right' }));
      setLicense(plan);
    }
  };

  const onBillingSelect = () => {
    formButtonRef?.current?.click();
  };

  const billingCallback = response => {
    if (response?.error) return;
    setActiveStep(state => ({ index: 2, direction: 'right' }));
    const billingAdress = response.result?.resultData?.data;
    setBillingAdress(billingAdress || {});
  };

  const paymentCallBack = () => {
    setActiveStep(state => ({ index: 3, direction: 'right' }));

  };


  const steps = [
    { name: 'Lisans Planları', backgroundStyle: 'bg-white', component: <Plans onSelect={onPlanSelect} /> },
    {
      name: 'Fatura Bilgileri',
      backgroundStyle: 'bg-white',
      button: { name: 'Kaydet ve Devam Et', callback: onBillingSelect },
      component: <BillingMain formButtonRef={formButtonRef}
        callback={billingCallback} />,
    },
    { name: 'Ödeme', renderAsync: true, component: <Payment license={license} billingAdress={billingAdress} updateBillingAddress={() => { setActiveStep(state => ({ index: state.index - 1, direction: 'left' })) }} callback={paymentCallBack} /> },
  ];

  return (
    <>
      <LayeredDashboardHeader tab={tab}></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-60px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1270px] mx-auto gap-[20px]">
            <Stepper activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LicensePurchase;
